import { styled } from '@material-ui/core/styles'
import { InputLabel } from '@material-ui/core'

export const SessionInputLabel = styled(InputLabel)({
  color: '#b6bec8'
})
